import { getApi } from '@BUP/services/Axios'

export const fetchAll = ( organizationId ) => async () => {
  const client = await getApi('schools', { authenticated: true, version: 3 })
  return client
    .get(`/organizations/${organizationId}/terms`)
    .then(response => response.data)
}
